import { createSlice } from "@reduxjs/toolkit";

const newsSlice = createSlice({
  name: "news",
  initialState: {
    isLoading: false,
    newsList: [],
    currentNews: {},
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setNewsList(state, action) {
      state.newsList = action.payload;
    },
    setCurrentNews(state, action) {
      state.currentNews = action.payload;
    },
  },
});

export const { setIsLoading, setNewsList, setCurrentNews } = newsSlice.actions;
export default newsSlice.reducer;
